import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialFloatOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {vec3} from "#material/types/vector"

export interface FresnelSockets extends MaterialNodeSockets {
    inputs: {
        ior: "float" // found in inputs: float; found in settings: float; inferred from data: float
        normal: "normal" // found in inputs: normal; found in settings: vector; inferred from data: float3
    }
    settings: {
        fac: "float" // found in inputs: -; found in settings: float; inferred from data: float
        ior: "float" // found in inputs: float; found in settings: float; inferred from data: float
        normal: "normal" // found in inputs: normal; found in settings: vector; inferred from data: float3
    }
    outputs: {
        fac: "float"
    }
}

export const fresnelDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeFresnel,
    },
    nodeClass: "Fresnel",
    ui: {
        label: "Fresnel",
        color: "#6e5eb2",
        items: [
            {name: "fac", valueType: "float", label: "Fac", output: true},
            {name: "ior", valueType: "float", label: "IOR", input: true, setting: true, defaultValue: 1.5},
            {name: "normal", valueType: "normal", label: "Normal", input: true, setting: true, defaultValue: {x: 0, y: 0, z: 0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({fac: materialFloatOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({ior: optionalMaterialInput, normal: optionalMaterialInput}),
            settings: z.strictObject({ior: z.optional(z.number()), fac: z.optional(z.number()), normal: z.optional(vec3)}),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<FresnelSockets>
